import type { HttpPost } from '@/shared/infra/http'
import type { Todo } from '@/shared/domain/todo'
import type { LogItemTodo } from '@/shared/domain/use-cases'

type LogItemTodoBody = { cost?: number; completionNotes?: string }

export class EdgeLogItemTodoRepository {
  constructor(private readonly http: HttpPost) {}

  execute: LogItemTodo = async ({ id, cost, completionNotes }) => {
    const hasBody = cost !== undefined || completionNotes !== undefined
    const response = await this.http.post<LogItemTodoBody | undefined, { todo: Todo }>({
      url: `/todos/${encodeURIComponent(id)}/complete`,
      body: hasBody ? { cost, completionNotes } : undefined,
    })
    return response.todo
  }
}
